export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/Factory-Paint.c2cb40bc.gif","height":239,"width":500,"blurWidth":0,"blurHeight":0};